import { Compound } from 'pubchem';

/**
 * We check that the hazards are present in the reagents
 * @param {object} reagent
 */
export async function ensureHazardAndPhysical(reagent, options = {}) {
  const { logger } = options;
  if (reagent.hazards) return;

  try {
    const compound = await Compound.fromSmiles(reagent.smiles);
    const data = await compound.getData();
    const summary = data.getGHSSummary({ sourceName: 'European' });
    reagent.hStatements = summary.hStatements;
    reagent.hazards = reagent.hStatements.map((h) => h.code);
  } catch (e) {
    logger.error(
      `Could not get hazards for ${reagent.smiles}: ${e.toString()}`,
    );
    reagent.hStatements = [];
    reagent.hazards = [];
  }
}
